var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSortDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9940_9645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74316 3.05078L20.7578 3.05078V5.05078L2.74316 5.05078L2.74316 3.05078ZM14.4218 8.74636H20.7578V10.7464H14.4218L14.4218 8.74636ZM11.6329 13.4221H20.7578V15.4221H11.6329V13.4221ZM14.4218 18.9495H20.7578V20.9495L14.4218 20.9495V18.9495ZM9.93934 10L7.96967 8.03033L9.03033 6.96967L11.5303 9.46967L12.0607 10L11.5303 10.5303L9.03033 13.0303L7.96967 11.9697L9.93934 10ZM7.96967 18.0303L9.93934 20L7.96967 21.9697L9.03033 23.0303L11.5303 20.5303L12.0607 20L11.5303 19.4697L9.03033 16.9697L7.96967 18.0303Z",
    fill: "#7B8389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10L8 10C5.23858 10 3 12.2386 3 15C3 17.7614 5.23858 20 8 20H11",
    stroke: "#7B8389",
    strokeWidth: 1.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9940_9645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortDnd);
export default __webpack_public_path__ + "static/media/icon_sort_dnd.0d6876eb5a908215d62e4453739a24c0.svg";
export { ForwardRef as ReactComponent };